import { useSite } from "../context/SiteContext";
import { shouldShowAfterHours } from "../lib/afterhours";
import { bust } from "../lib/imgUrl";
import { openWA, KISS } from "../lib/wa";
import { trackOf, trackWa, trackCall } from "../lib/analytics";

export default function Hero() {
  const { content, settings, versions } = useSite();
  const afterHours = shouldShowAfterHours(settings.after_hours_mode);

  const primaryCta = afterHours
    ? {
        label: "Sext me on OnlyFans 🔥",
        onClick: () => {
          trackOf("hero_after_hours");
          window.open(content.onlyfans, "_blank", "noopener,noreferrer");
        },
        testId: "hero-of-cta-btn",
      }
    : {
        label: "Book on WhatsApp",
        onClick: () => {
          trackWa("hero_cta");
          openWA(
            `Hi Camilla ${KISS} — I'd like to book you. When are you available?`
          );
        },
        testId: "hero-book-wa-btn",
      };

  return (
    <section
      id="top"
      className="relative min-h-[calc(100svh-88px)] flex items-end overflow-hidden -mt-[72px] pt-[72px]"
      data-testid="hero-section"
    >
      <div className="absolute inset-0 vignette">
        <img
          src={bust("/gallery/hero.jpg", versions)}
          alt="Camilla"
          className="w-full h-full object-cover"
          style={{ objectPosition: "center 30%" }}
          onContextMenu={(e) => e.preventDefault()}
          draggable={false}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[rgba(10,10,10,0.75)] to-[rgba(10,10,10,0.45)] md:via-[rgba(10,10,10,0.55)] md:to-[rgba(10,10,10,0.25)]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[rgba(10,10,10,0.75)] via-[rgba(10,10,10,0.35)] to-transparent md:from-[rgba(10,10,10,0.55)] md:via-transparent" />
      </div>

      <div className="relative z-10 container-x px-5 md:px-8 pb-16 md:pb-24 pt-16 md:pt-24 w-full">
        <div className="max-w-2xl">
          {settings.available_now && !afterHours && (
            <div
              className="inline-flex items-center gap-2.5 mb-6 px-3 py-1.5 rounded-full border border-[rgba(110,224,137,0.35)] bg-[rgba(110,224,137,0.06)]"
              data-testid="available-badge"
            >
              <span className="pulse-dot" />
              <span className="text-[color:#a8e0b7] text-[0.7rem] tracking-[0.2em] uppercase">
                Available now
              </span>
            </div>
          )}
          {afterHours && (
            <div
              className="inline-flex items-center gap-2.5 mb-6 px-3 py-1.5 rounded-full border border-[rgba(229,119,134,0.35)] bg-[rgba(229,119,134,0.08)]"
              data-testid="afterhours-badge"
            >
              <span>😴</span>
              <span className="text-[color:#e57786] text-[0.7rem] tracking-[0.2em] uppercase">
                In bed — sext me on OF
              </span>
            </div>
          )}

          <div className="eyebrow mb-5" data-testid="hero-eyebrow">
            Sydney · Turkish-Aussie · 18+
          </div>

          <h1
            className="font-display text-6xl sm:text-7xl md:text-8xl leading-[0.95] text-ivory mb-4"
            data-testid="hero-brand"
          >
            <span className="text-gold">Camilla</span>{" "}
            <span className="italic text-ivory-dim">XXX</span>
          </h1>

          <p
            className="font-serif italic text-2xl md:text-3xl text-gold-2 mb-6"
            data-testid="hero-tagline"
          >
            {content.tagline}
          </p>

          <p className="text-ivory-dim text-base md:text-lg max-w-xl leading-relaxed mb-9">
            {content.hero_blurb}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              className={afterHours ? "btn-gold" : "btn-wine"}
              onClick={primaryCta.onClick}
              data-testid={primaryCta.testId}
            >
              {primaryCta.label}
            </button>
            <a
              href="#rates"
              className="btn-ghost-gold"
              data-testid="hero-view-rates-btn"
            >
              View Rates
            </a>
          </div>

          <div className="mt-8" data-testid="hero-call-block">
            <div className="eyebrow mb-2 text-[color:var(--gold-soft)]">
              Prefer to call? <span aria-hidden>📞</span>
            </div>
            <a
              href={`tel:${(content.contact?.phone_intl || "+61437780132").replace(/\s+/g, "")}`}
              onClick={() => trackCall("hero_phone")}
              className="hero-phone-link"
              data-testid="hero-phone-link"
            >
              {content.contact?.phone_display || "0437 780 132"}
            </a>
          </div>

          <div
            className="mt-12 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs md:text-sm text-ivory-dim tracking-wider uppercase"
            data-testid="hero-quickstrip"
          >
            <span>Liverpool incalls</span>
            <span className="text-[color:var(--gold-soft)]">◆</span>
            <span>Sydney metro outcalls</span>
            <span className="text-[color:var(--gold-soft)]">◆</span>
            <span>WhatsApp only</span>
          </div>
        </div>
      </div>
    </section>
  );
}
